import { Icon } from "@chakra-ui/react";

export default function Arrow(props) {
  return (
    <Icon width="44px" height="24px" viewBox="0 6 64 24" {...props}>
      <path
        fill="currentColor"
        d="M49.542031,8 L48.1218971,9.38132296 L53.4123959,14.5272374 L3,14.5272374 L3,16.4727626 L53.4123959,16.4727626 L48.1218971,21.618677 L49.542031,23 L55.1225571,17.5622568 C56.292481,16.4228889 56.292481,14.5771111 55.1225571,13.4377432 L49.542031,8 Z"
        id="Style"
      />
    </Icon>
  );
}
